export default __webpack_public_path__ + "static/case2_img_2@2x-6dacd4e5aeec9a869f5feb37df5ae8b0.webp";